import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import moment from "moment-timezone";
import { Link } from "react-router-dom";
import { graphColor } from "../BreachConstants";
import ExclamationIcon from "../../../Assets/images/Exclamation_Triangle_Icon.svg";

const TD = ({ children, style = {}, className }: any) => {
    return (
        <td className={className} style={{ color: "#00313c", ...style }}>
            {children}
        </td>
    );
};

const DetectedBreachTableBody = ({ rowBreachData, detectedPage, titleNameDetectedBreach }: any) => {
    const [viewMore, setViewMore] = useState<any>(null);
    const history = useHistory();
    const handleRedirect = (id: number, orgName: string, breachDate: any) => {
        history.push({
            pathname: `/breaches/breach-details`,
            state: { id, backPage: "breach_exposure", orgName, breachDate },
        });
    };

    useEffect(() => {
        if (rowBreachData.length) {
            let breachIdList = {};
            rowBreachData.forEach((item: any) => {
                breachIdList = { ...breachIdList, [item.breachId]: false };
            });
            setViewMore(breachIdList);
        }
    }, [rowBreachData.length]);

    let res = rowBreachData.length ? rowBreachData.slice(detectedPage === 1 ? 0 : (detectedPage - 1) * 5, detectedPage * 5) : [];

    return res.length
        ? res.map((item: any, i: any) => {
              let affectedDataTypeList = JSON.parse(item.credentialList);
              return (
                  <tr key={item.breachId} className={item.status === "NEW" ? "new-card-bg" : ""}>
                      <TD
                          className={
                              titleNameDetectedBreach === "organization"
                                  ? "breach-organization border-top-bottom vertical-align-top highlight-exposure-table-body bold"
                                  : "breach-organization border-top-bottom vertical-align-top bold"
                          }
                      >
                          <div className="my-exposure-org-name" onClick={() => handleRedirect(item.breachId, item.organization, item.breachDate)}>
                              {item.organization}
                          </div>
                          <div className="show-exposure-col">{moment(item.breachDate).format("MM/YYYY")}</div>
                      </TD>

                      <TD
                          className={
                              titleNameDetectedBreach === "breachDate"
                                  ? "border-top-bottom vertical-align-top highlight-exposure-table-body hide-exposure-col"
                                  : "border-top-bottom vertical-align-top hide-exposure-col"
                          }
                      >
                          <div style={{ padding: "1rem 10px 10px 10px" }}>{moment(item.breachDate).format("MM/YYYY")}</div>
                      </TD>

                      <TD className="border-top-bottom vertical-align-middle hide-exposure-col">
                          <ul style={{ margin: "10px 1rem", fontSize: "0.75rem" }}>
                              {affectedDataTypeList.length &&
                                  affectedDataTypeList.map((listItem: string, index: number) => {
                                      if (index < 2 && viewMore && !viewMore[item.breachId]) {
                                          return (
                                              <li className="list-style-disc" key={`${index}-${listItem}`} style={{ paddingBottom: "0.3rem" }}>
                                                  <span style={{ lineHeight: 1.2 }}>{listItem}</span>
                                              </li>
                                          );
                                      } else if (viewMore && viewMore[item.breachId]) {
                                          return (
                                              <li className="list-style-disc" key={`${index}-${listItem}`} style={{ paddingBottom: "0.3rem" }}>
                                                  <span style={{ lineHeight: 1.2 }}>{listItem}</span>
                                              </li>
                                          );
                                      } else {
                                          return null;
                                      }
                                  })}
                              {affectedDataTypeList.length && affectedDataTypeList.length > 2 ? (
                                  viewMore && !viewMore[item.breachId] ? (
                                      <Link
                                          to="/"
                                          className="default_link"
                                          style={{ padding: "5px 0px" }}
                                          onClick={(e: any) => {
                                              e.preventDefault();
                                              setViewMore({ ...viewMore, [item.breachId]: true });
                                          }}
                                      >
                                          {`View ${affectedDataTypeList.length - 2} more data types`}
                                      </Link>
                                  ) : (
                                      <Link
                                          to="/"
                                          className="default_link"
                                          style={{ padding: "5px 0px" }}
                                          onClick={(e: any) => {
                                              e.preventDefault();
                                              setViewMore({ ...viewMore, [item.breachId]: false });
                                          }}
                                      >
                                          {`Collapse data types`}
                                      </Link>
                                  )
                              ) : null}
                          </ul>
                      </TD>

                      <TD
                          className={
                              titleNameDetectedBreach === "breachRiskRating"
                                  ? "border-top-bottom input-card highlight-exposure-table-body"
                                  : "border-top-bottom input-card"
                          }
                      >
                          <div className="breach-exposure-risk-rating-card">
                              <div className="breach-exposure-score-card">
                                  <span className={`risk-score ${graphColor[item.score]["textColor"]}`}>{item.score}</span>

                                  <div className={`exposure-risk-score-card ${graphColor[item.score]["cardBg"]}`}>
                                      <span className={`risk-label ${graphColor[item.score]["textColor"]}`}>{graphColor[item.score]["text"]}</span>
                                      <span className={`risk-label-score ${graphColor[item.score]["textColor"]}`}>{`(${item.score} of 10)`}</span>
                                  </div>
                              </div>
                          </div>
                      </TD>
                      <TD
                          className={`breach-risk-rating-table ${
                              item.status === "NEW"
                                  ? titleNameDetectedBreach === "breachRiskRating"
                                      ? "table-new-breach-exposure highlight-exposure-table-body"
                                      : "table-new-breach-exposure"
                                  : titleNameDetectedBreach === "breachRiskRating"
                                  ? "border-top-bottom highlight-exposure-table-body"
                                  : "border-top-bottom"
                          }`}
                      >
                          {item.status === "NEW" && (
                              <div className="new-detected-breach-text">
                                  <span>
                                      <img src={ExclamationIcon} alt="Triangle with an exclamation point in the center signifying a warning" />
                                  </span>
                                  <span className="new-detected-breach-label">{item.status}</span>
                              </div>
                          )}
                      </TD>
                  </tr>
              );
          })
        : null;
};

export default DetectedBreachTableBody;
